import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { PageLink, PageTitle } from "../../../../_metronic/layout/core";
import { EmployeeList } from "./EmployeeList";

const companyBreadcrumbs: Array<PageLink> = [
  {
    title: "Employee Management",
    path: "/employees/list",
    isSeparator: false,
    isActive: false,
  },
  {
    title: "",
    path: "",
    isSeparator: true,
    isActive: false,
  },
];

const EmployeePage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path="list"
          element={
            <>
              <PageTitle breadcrumbs={companyBreadcrumbs}>Employee list</PageTitle>
              <EmployeeList/>
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to="/employees/list" />} />
    </Routes>
  );
};

export default EmployeePage;
